import { useCallback, useEffect } from 'react'
import { fetchCruiseDeals } from 'actions/CruiseActions'
import { useAppDispatch, useAppSelector, shallowEqual } from 'hooks/reduxHooks'

export interface UseCruiseDeals {
  deals: Array<App.Cruises.CruiseDealBase>
  isLoading: boolean
  hasMore: boolean
  loadMore: () => void
}

export function useCruiseDeals(): UseCruiseDeals {
  const dispatch = useAppDispatch()
  const { deals, fetching, total } = useAppSelector((state) => ({
    deals: state.cruise.cruiseDeals,
    total: state.cruise.cruiseDealsTotal,
    fetching: state.cruise.fetchingCruiseDeals,
  }), shallowEqual)

  useEffect(() => {
    dispatch(fetchCruiseDeals())
  }, [dispatch])

  const loadMore = useCallback(() => {
    dispatch(fetchCruiseDeals(deals.length))
  }, [deals.length, dispatch])

  return {
    deals,
    isLoading: fetching,
    hasMore: deals.length < total,
    loadMore,
  }
}
